import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/location'

const locations = async (id, edate, sdate, page, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }

  const options = {
    method: 'GET',
    url: apiUrlEx + '/locations-list',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id: id,
      sdate: sdate,
      edate: edate,
      page: page || 1
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })
}

const historyLocations = async (cseq, sdate, edate, page, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx + '/history-locations',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      cseq: cseq,
      sdate: sdate,
      edate: edate,
      page: page || 1
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })
}

const mapLocations = async (target, result) => {
  let finalData = []
  const options = {
    method: 'GET',
    url: apiUrlEx + '/map-locations',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      id: target.id,
      sdate: target.sdate,
      edate: target.edate
    }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })
}

const lastGps = async (id, result) => {
  let finalData = []
  const options = {
    method: 'GET',
    url: apiUrlEx + '/last-gps',
    params: {
      id: id
    }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData = response.data.data
        result(finalData)
      } else {
        result(null)
      }
    })
}

export default {
  locations,
  historyLocations,
  mapLocations,
  lastGps
}
